const Form = {
    $forms: null,
    autoResizeTextarea(textarea$, value) {
      if (value === '') {
        textarea$.style.maxHeight = null;
        textarea$.style.height = null;
        return;
      }
      textarea$.style.height = 'auto';
      textarea$.style.height = `${textarea$.scrollHeight}px`;

      textarea$.style.maxHeight = 'auto';
      textarea$.style.maxHeight = `${textarea$.scrollHeight}px`;
    },

    bindTextarea(form$) {
      const textarea$ = DOM.find(form$, '[data-selector="form.textarea"]');
      if (textarea$) {
        form$.addEventListener('input', (event) => {
          if (event.target.tagName !== 'TEXTAREA') return;
          Form.autoResizeTextarea(textarea$, event.target.value);
        });
      }
    },

    bindEvents(form$) {
      const recaptchaType = form$?.dataset?.recaptcha;

      form$.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (form$.__isSubmitting) return;
        form$.__isSubmitting = true;

        const submitButton$ = form$.querySelector('button[type="submit"], input[type="submit"]');
        Form.toggleSubmitState(submitButton$, true);
        Form.setStatus(form$, '', '');

        try {
          let recaptchaReady = true;
          if (recaptchaType === 'v3') {
            recaptchaReady = await Form.fillRecaptchaToken(form$);
            Form.setRecaptchaStatus(form$, recaptchaReady ? '' : 'service_unavailable');
          }

          const response = await fetch(form$.action, {
            method: (form$.method || 'POST').toUpperCase(),
            body: new FormData(form$),
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json',
            },
          });

          const payload = await response.json().catch(() => ({}));

          if (!response.ok) {
            const firstValidationError = payload?.errors
              ? Object.values(payload.errors)?.[0]?.[0]
              : null;
            throw new Error(firstValidationError || payload?.message || 'Не удалось отправить заявку. Попробуйте еще раз.');
          }

          Form.setStatus(form$, payload?.message || 'Заявка отправлена. Мы скоро свяжемся с вами.', 'success');
          form$.reset();
        } catch (error) {
          Form.setStatus(form$, error?.message || 'Ошибка отправки формы.', 'error');
        } finally {
          Form.toggleSubmitState(submitButton$, false);
          form$.__isSubmitting = false;
        }
      });
    },

    toggleSubmitState(button$, isLoading) {
      if (!button$) return;
      if (!button$.__initialText) {
        button$.__initialText = button$.textContent;
      }

      button$.disabled = isLoading;
      button$.textContent = isLoading ? 'Отправка...' : button$.__initialText;
    },

    setStatus(form$, message, type) {
      const status$ = DOM.find(form$, '[data-selector="form.status"]');
      if (!status$) return;

      status$.textContent = message || '';
      status$.style.display = message ? 'block' : 'none';
      status$.style.color = type === 'success' ? '#229d59' : '#d14124';
    },

    fillRecaptchaToken(form$) {
      return new Promise(async (resolve) => {
        const siteKey = Form.getRecaptchaSiteKey(form$);
        if (!siteKey) {
          resolve(false);
          return;
        }

        const isReady = await Form.waitForRecaptcha(10000);
        if (!isReady) {
          resolve(false);
          return;
        }

        const action = form$.dataset?.recaptchaAction || 'market_form';
        const input$ = Form.ensureRecaptchaInput(form$);

        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(siteKey, { action })
            .then((token) => {
              if (!token) {
                resolve(false);
                return;
              }
              input$.value = token;
              resolve(true);
            })
            .catch(() => {
              resolve(false);
            });
        });
      });
    },

    waitForRecaptcha(timeoutMs = 10000) {
      return new Promise((resolve) => {
        const startedAt = Date.now();
        const timer = setInterval(() => {
          const isReady = !!window.grecaptcha && typeof window.grecaptcha.execute === 'function';
          if (isReady) {
            clearInterval(timer);
            resolve(true);
            return;
          }

          if (Date.now() - startedAt >= timeoutMs) {
            clearInterval(timer);
            resolve(false);
          }
        }, 100);
      });
    },

    getRecaptchaSiteKey(form$) {
      const inlineKey = form$?.dataset?.recaptchaSiteKey;
      if (inlineKey) return inlineKey;

      const meta = document.querySelector('meta[name="recaptcha-site-key"]');
      return meta?.getAttribute('content');
    },

    ensureRecaptchaInput(form$) {
      let input$ = DOM.find(form$, 'input[name="g-recaptcha-response"]');
      if (!input$) {
        input$ = document.createElement('input');
        input$.type = 'hidden';
        input$.name = 'g-recaptcha-response';
        form$.appendChild(input$);
      }
      return input$;
    },

    setRecaptchaStatus(form$, status) {
      let input$ = DOM.find(form$, 'input[name="recaptcha_status"]');
      if (!input$) {
        input$ = document.createElement('input');
        input$.type = 'hidden';
        input$.name = 'recaptcha_status';
        form$.appendChild(input$);
      }
      input$.value = status || '';
    },
  
    init() {
      this.$forms = DOM.select('[data-selector="form"]', true);

      if (!this.$forms?.length) return;

      this.$forms.forEach(form => {
        Form.bindEvents(form);
        Form.bindTextarea(form);
      })
    }
  };
  
  export default Form;
